import React from "react";
import BusinessCancellationPolicy from "../../../../../../components/cancellation-policy/business/cancellation-policy";
import BusinessSamedayReschedulePolicy from "../../../../../../components/cancellation-policy/business/same-day";
import BusinessMeetAssistCancellationPolicy from "../../../../../../components/cancellation-policy/business/meet-assist";
import GeneralCancellationPolicy from "../../../../../../components/cancellation-policy/general/cancellation-policy";
import { MotionModal, ModalCloseButton } from "../../../../../../components/motion";

const CancellationPolicyModal = ({
    show,
    onClose,
    role = "individual"
}) => {
    return (
        <MotionModal
            show={show}
            onClose={onClose}
            maxWidthClassName="tw:max-w-[1000px]"
            panelClassName="tw:px-4 tw:py-6 tw:md:px-10 tw:md:py-8 tw:max-h-[90vh] tw:flex tw:flex-col"
        >
            <style>
                {`
                .policy-scrollbar::-webkit-scrollbar {
                    width: 6px;
                }
                .policy-scrollbar::-webkit-scrollbar-track {
                    background: transparent;
                }
                .policy-scrollbar::-webkit-scrollbar-thumb {
                    background: #7C7B7B;
                    border-radius: 10px;
                }
                `}
            </style>
                <div className="tw:flex tw:items-center tw:justify-between tw:mb-4">
                    <div className="tw:text-[#282828] tw:text-[20px] tw:font-[600] tw:leading-normal tw:font-hanken-grotesk">
                        Cancellation Policy
                    </div>
                    <ModalCloseButton isInline onClick={onClose} />
                </div>

                <div className="tw:flex-1 tw:overflow-y-auto policy-scrollbar tw:pr-2">
                    {
                        role === "business" ? (
                            <div className="tw:flex tw:flex-col tw:items-center tw:text-center">
                                <BusinessCancellationPolicy
                                    className="tw:!w-full tw:mx-auto tw:px-0"
                                />
                                <BusinessSamedayReschedulePolicy
                                    className="tw:!w-full tw:mx-auto tw:mt-12 tw:px-0"
                                />
                                <BusinessMeetAssistCancellationPolicy
                                    className="tw:!w-full tw:mx-auto tw:mt-12 tw:px-0"
                                />
                            </div>
                        ) : (
                            <div className="tw:flex tw:flex-col tw:items-center tw:text-center">
                                <GeneralCancellationPolicy />
                            </div>
                        )
                    }
                </div>
        </MotionModal>
    );
};

export default CancellationPolicyModal;
